import { useState } from 'react';
import { Table } from 'react-bootstrap';
import { Modal } from '../../../../common/components/modals';
import { UserModel } from '../../models/payrollNoveltyFlow';
import { UserItemModel } from '../../models/UserItem';

export interface AddUserModalProps {
    isOpen: boolean;
    onConfirm: (data: UserItemModel[]) => void;
    onClose: () => void;
    dataSelected: UserModel[];
    data: UserItemModel[];
}

export const AddUserModal = ({
    onClose,
    onConfirm,
    isOpen,
    data,
    dataSelected,
}: AddUserModalProps) => {
    const [selectedUsers, setselectedUsers] = useState<UserItemModel[]>(
        dataSelected
            ? [
                  ...dataSelected?.map((d) => {
                      return {
                          fullName: d.fullName,
                          id: d.userId,
                      };
                  }),
              ]
            : []
    );
    const [searchTerm, setSearchTerm] = useState('');
    const [dataCopy, setDataCopy] = useState<UserItemModel[]>([...data]);

    const handleChangeSelectedUsers = (user: UserItemModel) => {
        let newList = [...selectedUsers];

        if (newList.find((u) => u.fullName == user.fullName)) {
            newList = newList.filter((u) => u.fullName !== user.fullName);
        } else {
            newList = newList.concat(user);
        }

        setselectedUsers(newList);
    };

    const handlerSubmit = () => {
        onConfirm(selectedUsers);
    };

    const onSearch = (term: string) => {
        if (term == '') {
            setDataCopy([...data]);
        } else {
            let filterData = data.filter((d) =>
                d.fullName.toLowerCase().includes(term.toLowerCase())
            );
            setDataCopy(filterData);
        }
        setSearchTerm(term);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle='Agregar Usuarios'
            disableSubmit={selectedUsers?.length == 0}
            onSubmit={handlerSubmit}
            onClose={onClose}
            widthCustom='700px'
        >
            <div>
                <div
                    style={{
                        background: '#fff',
                        position: 'relative',
                    }}
                >
                    <i
                        className='ri-search-line'
                        style={{
                            position: 'absolute',
                            top: '25%',
                            left: '10px',
                            color: '#9F9FA0',
                        }}
                    ></i>
                    <input
                        className='form-control text-dark'
                        style={{
                            background: 'transparent',
                            paddingLeft: '25px',
                        }}
                        value={searchTerm}
                        id='exampleDataList'
                        placeholder={'Buscar...'}
                        onChange={(e) => onSearch(e.target.value)}
                    />
                </div>

                {dataCopy?.length > 0 ? (
                    <div className='table-responsive mt-2'>
                        <Table className='table-striped table-nowrap align-middle mb-0 text-dark'>
                            <thead>
                                <tr>
                                    <th scope='col'>Seleccionar</th>
                                    <th scope='col'>Nombre usuario</th>
                                </tr>
                            </thead>
                            <tbody className='text-dark '>
                                {dataCopy?.map((user, i) => (
                                    <tr key={user.id + '-i'}>
                                        <td className='text-dark checked-custom'>
                                            <input
                                                checked={
                                                    !!selectedUsers.find(
                                                        (u) =>
                                                            u.fullName ==
                                                            user.fullName
                                                    )
                                                }
                                                type='checkbox'
                                                className='form-check-input'
                                                onChange={(e) =>
                                                    handleChangeSelectedUsers(user)
                                                }
                                            />
                                        </td>
                                        <td className='text-dark'>
                                            {user.fullName.toUpperCase()}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <p>No hay usuarios...</p>
                )}
            </div>
        </Modal>
    );
};
